import {useState} from 'react';
import {getPublicCBStandardsByEconomy} from 'api/certification-bodies';
import {alertByError} from 'utils/alerts';

function useGetCBStandardsEconomy(cbId, abId, countriesId) {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState({});

  async function getData(query) {
    setIsLoading(true);
    try {
      const {data, meta} = await getPublicCBStandardsByEconomy(cbId, {
        accreditation_bodies_id: abId,
        countries_id: countriesId,
        limit: 10,
        ...query,
      });

      setData(data);
      setMeta(meta);
    } catch (e) {
      alertByError(e);
    } finally {
      setIsLoading(false);
    }
  }

  return {
    meta,
    data,
    isLoading,
    reload: getData,
  };
}

export default useGetCBStandardsEconomy;
